import { IPaginatedData } from '.';

export interface IAPIResponse<T> {
  success: boolean;
  data: T;
}

export interface IAPIPaginatedResponse<T> {
  success: boolean;
  data: IPaginatedData<T>;
}
